import React from 'react';

const Blog = () => {
    return (
        <div>
            <h2>Coming Soon</h2>
        </div>
    );
};

export default Blog;